export default __webpack_public_path__ + "static/stock-motorcycle-f53a6b2cd9bedcc0db807dbf4af3cc6b.jpg";